/**
 * @generated SignedSource<<02c102e6ac6e454cb16c6cb1ec073806>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EntityKind = "ORGANIZATION" | "USER";
export type UserAutocompleteFragmentPaginationQuery$variables = {
  count?: number | null | undefined;
  kinds?: ReadonlyArray<EntityKind> | null | undefined;
  search?: string | null | undefined;
};
export type UserAutocompleteFragmentPaginationQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"UserAutocompleteFragment">;
};
export type UserAutocompleteFragmentPaginationQuery = {
  response: UserAutocompleteFragmentPaginationQuery$data;
  variables: UserAutocompleteFragmentPaginationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": 10,
    "kind": "LocalArgument",
    "name": "count"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "kinds"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "search"
  }
],
v1 = {
  "kind": "Variable",
  "name": "kinds",
  "variableName": "kinds"
},
v2 = {
  "kind": "Variable",
  "name": "search",
  "variableName": "search"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UserAutocompleteFragmentPaginationQuery",
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "count",
            "variableName": "count"
          },
          (v1/*: any*/),
          (v2/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "UserAutocompleteFragment"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UserAutocompleteFragmentPaginationQuery",
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "first",
            "variableName": "count"
          },
          (v1/*: any*/),
          (v2/*: any*/)
        ],
        "concreteType": "EntityConnection",
        "kind": "LinkedField",
        "name": "entities",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "EntityEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "kind",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "username",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "displayName",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "34f3e778beeb4fba30a59a2db68338d6",
    "id": null,
    "metadata": {},
    "name": "UserAutocompleteFragmentPaginationQuery",
    "operationKind": "query",
    "text": "query UserAutocompleteFragmentPaginationQuery(\n  $count: Int = 10\n  $kinds: [EntityKind!]\n  $search: String\n) {\n  ...UserAutocompleteFragment_43Pscm\n}\n\nfragment UserAutocompleteFragment_43Pscm on Query {\n  entities(first: $count, search: $search, kinds: $kinds) {\n    edges {\n      node {\n        __typename\n        id\n        kind\n        username\n        displayName\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "bff2636b0e0baff48f26259ad5d459ba";

export default node;
